// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-area {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .datepicker-container {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
  }
  
  .datepicker-label {
    font-weight: bold;
    margin-bottom: 8px;
  }
  
  .react-datepicker-wrapper {
    width: 100%;
    display: flex;
  }
  
  .react-datepicker__input-container input {
    width: 100%;
    height: 100%;
  }
  .react-datepicker__input-container input:hover {
  }
  
  .react-datepicker__input {
    width: 100%;
    height: 56px;
    padding-right: 40px; /* space for the icon */
    font-size: 14px;
    border-radius: 4px;
    box-sizing: border-box;
    transition: border 0.3s ease; /* Smooth transition for border change */
  }
  
  /* Hover effect to increase the border thickness to 2px */
  .react-datepicker__input:hover {
    /* border: 2px solid red; */
  }
  
  .react-datepicker__time-container {
  }
  
  .react-datepicker-popper {
    z-index: 9999;
  }
  
  .datepicker-icon {
    position: absolute;
    right: 10px;
    top: 18px;
    font-size: 20px;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/pages/AccessManagement/Delegation/Delegation.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;EACA;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAE,uBAAuB;IAC5C,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B,EAAE,wCAAwC;EACxE;;EAEA,yDAAyD;EACzD;IACE,2BAA2B;EAC7B;;EAEA;EACA;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,eAAe;EACjB","sourcesContent":[".main-area {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .datepicker-container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n  \n  .datepicker-label {\n    font-weight: bold;\n    margin-bottom: 8px;\n  }\n  \n  .react-datepicker-wrapper {\n    width: 100%;\n    display: flex;\n  }\n  \n  .react-datepicker__input-container input {\n    width: 100%;\n    height: 100%;\n  }\n  .react-datepicker__input-container input:hover {\n  }\n  \n  .react-datepicker__input {\n    width: 100%;\n    height: 56px;\n    padding-right: 40px; /* space for the icon */\n    font-size: 14px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    transition: border 0.3s ease; /* Smooth transition for border change */\n  }\n  \n  /* Hover effect to increase the border thickness to 2px */\n  .react-datepicker__input:hover {\n    /* border: 2px solid red; */\n  }\n  \n  .react-datepicker__time-container {\n  }\n  \n  .react-datepicker-popper {\n    z-index: 9999;\n  }\n  \n  .datepicker-icon {\n    position: absolute;\n    right: 10px;\n    top: 18px;\n    font-size: 20px;\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
